module.exports = new __parcel__URL__("insight-object-modal-fields-skeleton.tpl.4e28af6a.svg").toString();